import { configureStore } from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';
import LocationManagerSlice from './location/LocationManagerSlice';
import AgentManagerSlice from './agent/AgentManagerSlice';
import FilterHotelSlice from './reservations/slices/hotels/FilterHotelSlice';
import FilterServiceSlice from './reservations/slices/services/FilterServiceSlice';
import SearchHotelSlice from './reservations/slices/hotels/SearchHotelSlice';
import HotelDetailSlice from './reservations/slices/hotels/HotelDetailSlice';
import ServiceTypeDetailSlice from './reservations/slices/services/ServiceTypeDetailSlice';
import ReservationsManagerSlice from './reservations/slices/ReservationsManagerSlice';
import PermissionSlice from './permissions/PermissionSlice';
import CountryManagerSlice from './countries/CountryManagerSlice';
import SearchServiceSlice from './reservations/slices/services/SearchServiceSlice';
import ReservationRequestItemsSlice from './reservations/slices/ReservationRequestItemsSlice';
import ManageHotelSlice from './reservations/slices/hotels/ManageHotelSlice';
import ManageGuestInformationSlice from './reservations/slices/hotels/ManageGuestInformationSlice';
import ManageServiceSlice from './reservations/slices/services/ManageServiceSlice';
import ChatSlice from './chat/ChatSlice';
import UserProfileSlice from './user/UserProfileSlice';
import MarkupManagerSlice from './markups/MarkupManagerSlice';
import ManageTransferSlice from './reservations/slices/transfers/ManageTransferSlice';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    locationReducer: LocationManagerSlice,
    agentReducer: AgentManagerSlice,
    hotelFilterReducer: FilterHotelSlice,
    serviceFilterReducer: FilterServiceSlice,
    hotelSearchReducer: SearchHotelSlice,
    hotelDetailReducer: HotelDetailSlice,
    serviceTypeDetailReducer: ServiceTypeDetailSlice,
    reservationsSummaryReducer: ReservationsManagerSlice,
    permissionsReducer: PermissionSlice,
    countryReducer: CountryManagerSlice,
    serviceSearchReducer: SearchServiceSlice,
    reservationRequestItemsReducer: ReservationRequestItemsSlice,
    hotelReducer: ManageHotelSlice,
    serviceReducer: ManageServiceSlice,
    guestInformationReducer: ManageGuestInformationSlice,
    chatReducer: ChatSlice,
    userProfileReducer: UserProfileSlice,
    markupReducer: MarkupManagerSlice,
    transferReducer: ManageTransferSlice
  },
});

export default store;
